import { useState } from "react";
import { Link } from "react-router-dom";
import { FiHeart  ,FiHome } from "react-icons/fi";
// import {  FiShoppingBag } from "react-icons/fi";
import { FiChevronDown } from "react-icons/fi";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { useWishlist } from "../context/WishlistContext";
import ShopDropdown from "./ShopDropdown";

const Navbar = () => {

const { wishlist } = useWishlist();
const [mobileOpen, setMobileOpen] = useState(false);

// const [user, setUser] = useState(() =>
// JSON.parse(localStorage.getItem("user") || "null")
// );

const role = localStorage.getItem("role");

// useEffect(() => {
// const handleStorage = () => {
// const storedUser = localStorage.getItem("user");

// setUser(storedUser ? JSON.parse(storedUser) : null);
// };

// window.addEventListener("storage", handleStorage);
// return () => window.removeEventListener("storage", handleStorage);

// }, []);


// MOBILE DRAWER MENU
const [categoryOpen, setCategoryOpen] = useState(false); 

const mobileMenu = (
  <div className="w-72 bg-white h-full flex flex-col p-6">

    <div className="flex justify-between items-center mb-6">
      <h2 className="text-lg font-semibold">SHOP</h2>

      <IconButton onClick={() => setMobileOpen(false)}>
        <CloseIcon />
      </IconButton>
    </div>

    <div className="flex flex-col text-base">
      {/* Collapsible By Category */}
      <div className="flex flex-col">
        <button
          className="flex justify-between items-center w-full font-semibold py-2 px-2 hover:bg-gray-100 rounded-md transition"
          onClick={() => setCategoryOpen(!categoryOpen)}
        >
          By Category
          <FiChevronDown
            className={`transition-transform duration-300 ${categoryOpen ? "rotate-180" : ""}`}
          />
        </button>

        {categoryOpen && (
          <div className="flex flex-col ml-4 mt-2 space-y-2">
            <Link
              to="/products?category=Floral"
              onClick={() => setMobileOpen(false)}
              className="hover:text-gray-700"
            >
              Floral
            </Link>
            <Link
              to="/products?category=Nature"
              onClick={() => setMobileOpen(false)}
              className="hover:text-gray-700"
            >
              Nature
            </Link>
            <Link
              to="/products?category=Contemporary"
              onClick={() => setMobileOpen(false)}
              className="hover:text-gray-700"
            >
              Contemporary
            </Link>
            <Link
              to="/products?category=BeachSide"
              onClick={() => setMobileOpen(false)}
              className="hover:text-gray-700"
            >
              BeachSide
            </Link>
            <Link
              to="/products?category=all"
              onClick={() => setMobileOpen(false)}
              className="hover:text-gray-700"
            >
              View All
            </Link>
          </div>
        )}
      </div>

      {/* Other links outside category */}
      <Link
        to="/contact"
        onClick={() => setMobileOpen(false)}
        className="py-2 px-2 hover:bg-gray-100 rounded-md mt-4"
      >
        Contact
      </Link>
    </div>
  </div>
);

return (

<>
<nav className="fixed top-0 left-0 w-full z-50 bg-black text-white shadow-md">

{/* MOBILE SHIPPING BAR */}
<div className="md:hidden bg-white text-black text-xs flex justify-between items-center px-4 py-2 border-b">

<span className="tracking-wide">FREE SHIPPING</span>



</div>


<div className="w-full px-6 lg:px-16">

<div className="flex items-center justify-between h-16">

{/* LOGO */}
<div className="flex items-center">
<Link to="/">
<h1 className="brand-logo">RITESH PURI</h1>
</Link>
</div>


{/* DESKTOP NAV */}
<div className="hidden md:flex justify-center">

<ul className="flex gap-8 text-base md:text-base font-normal tracking-wide items-center">

<li>
<Link to="/" className="hover:text-gray-300 transition">
Home
</Link>
</li>

<li>
<ShopDropdown />
</li>

<li>
<Link to="/contact" className="hover:text-gray-300 transition">
Contact
</Link>
</li>

</ul>

</div>


{/* RIGHT ICONS */}
<div className="flex items-center gap-5">


{/* HOME ICON - MOBILE ONLY */}
  <Link to="/" className="block md:hidden">
    <FiHome className="text-2xl cursor-pointer hover:text-gray-300 transition" />
  </Link>
<Link to="/wishlist" className="relative">

<FiHeart className="text-2xl md:text-3xl cursor-pointer hover:text-gray-300 transition" />

{wishlist.length > 0 && (
<span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
{wishlist.length}
</span>
)}

</Link>

{/* <Link to="/cart">
<FiShoppingBag className="text-2xl md:text-3xl cursor-pointer hover:text-gray-300 transition" />
</Link> */}
 


{/* MOBILE MENU ICON */}
<div className="md:hidden">

<IconButton onClick={() => setMobileOpen(true)}>
<MenuIcon style={{ color: "white" }} />
</IconButton>

</div>

</div>

</div>
</div>

</nav>


{/* DRAWER */}
<Drawer
anchor="left"
open={mobileOpen}
onClose={() => setMobileOpen(false)}
>
{mobileMenu}
</Drawer>


{role === "admin" && (
<Link to="/admin">Admin Panel</Link>
)}

</>

);

};

export default Navbar;